export const uk = {
    categories: 'Категории:',
    copied: 'Скопировано',
    'copy-error': 'Ошибка при копировании',
    description: 'Ретаргетинг и подбор аудитории, ключевые фразы',
    'description-keywords': 'ключевые фразы',
    'description-retargetings': 'ретаргетинг и подбор аудитории',
    'description-screens': 'рекламные площадки',
    'description-user-profile': 'профиль пользователя',
    formats: 'Форматы:',
    'go-to-edit-group': 'Перейти к редактированию группы',
    'hide-full-value': 'Скрыть все условия',
    'keywords-title': 'Ключевые фразы',
    'no-item': 'Не задан',
    'no-items': 'Не заданы',
    operators: 'Операторы:',
    regions: 'Регионы:',
    'retargeting-title': 'Ретаргетинг и подбор аудитории',
    screens: 'Экраны:',
    'screens-title': 'Рекламные площадки',
    'show-full-value': 'Показать все условия',
    title: 'Условия показа',
    'user-profile-title': 'Профиль пользователя',
    'zone-categories': 'Зоны размещения экранов:'
};
